export { default } from './UserList'


// WEBPACK FOOTER //
// ./src/scenes/Administration/User/UserList/index.js